import {Component, OnInit} from '@angular/core';
import {TowerService} from "../../api/service/tower.service";
import {isNullOrUndefined} from "util";
import {Router} from "@angular/router";
import {QueueDto} from "../../api/dto/queue.dto";
import {QueueMessageDto} from "../../api/dto/queue.message.dto";

@Component({
  selector: 'app-queues',
  templateUrl: './queues.component.html'
})
export class QueuesComponent implements OnInit{

  mode: string;
  queues: Array<QueueDto>;
  selectedQueue: QueueDto;
  messages: Array<QueueMessageDto>;

  constructor(private router: Router,
              private towerService: TowerService) {
  }

  ngOnInit(){
    this.listerQueues();
  }

  listerQueues(){
    this.queues = null;
    this.selectedQueue = null;
    this.messages = null;

    this.towerService.listerQueues().subscribe(
      resultat => {
        this.queues = resultat;
      }, error => {
        alert('Erreur durant la recherche');
      }
    );
  }

  queueStyleStandard(size: number){
    if(size > 0) {
      return {"background": "#ffff66"};
    } else {
      return {"background": "#66ff66"};
    }
  }

  queueStyleError(size: number){
    if(size > 0) {
      return {"background": "#ff3333", "cursor": "pointer"};
    } else {
      return {"background": "#66ff66"};
    }
  }

  queueStyleErrorInv(size: number){
    if(size > 0) {
      return {"background": "#ff9933"};
    } else {
      return {"background": "#66ff66"};
    }
  }

  selectQueue(queue: QueueDto){
    if(queue.errorAvailable == 0){
      return;
    }

    this.selectedQueue = queue;
    this.messages = null;

    this.towerService.lireQueue(queue.name).subscribe(
      messages => {
        this.messages = messages;
      }, error => {
        alert('Erreur durant la lecture');
      }
    );
  }

  moveMessage(message: QueueMessageDto){
    if(confirm("Réinjecter ce message ?")) {
      this.towerService.injecterMessage(this.selectedQueue.name, message).subscribe(
        res => {
          alert('Déplacement effectué');
          this.rafraichirMessages(message);
        }, err => {
          alert('Erreur durant le déplacement');
        });
    }
  }

  deleteMessage(message: QueueMessageDto){
    if(confirm("Supprimer ce message ?")) {
      this.towerService.supprimerMessage(this.selectedQueue.name, message).subscribe(
        res => {
          alert('Suppression effectuée');
          this.rafraichirMessages(message);
        }, err => {
          alert('Erreur durant le déplacement');
        });
    }
  }

  rafraichirMessages(message: QueueMessageDto){
    const msgs = [];
    for(const msg of this.messages){
      if(msg.id !== message.id){
        msgs.push(msg)
      }
    }
    this.messages = msgs;
  }
}



// WEBPACK FOOTER //
// ./src/app/page/queues/queues.component.ts